import { PropsWithChildren, useRef } from 'react'
import type {
  RawNonFilterParams,
  RawSearchFilters,
} from '@cinch-nx/data-search'
import {
  SearchStoreType,
  initialiseSearchStore,
} from './initialise-search-store'
import { SearchStoreContext } from './use-search-store'
import { useSsrExperiments } from '@cinch-nx/adobe-server-side'
import { Env, readFromEnv } from '@cinch-nx/environments'

export const SearchStoreProvider = ({
  children,
  params,
  isInsideStoryblok,
  allCinchStores,
  pathSegmentsFromUrl,
}: PropsWithChildren<{
  params: RawSearchFilters & RawNonFilterParams
  isInsideStoryblok: boolean
  allCinchStores: string[]
  pathSegmentsFromUrl: Partial<RawSearchFilters>
}>) => {
  const storeRef = useRef<SearchStoreType>()

  const { getExperienceIdForExperiment } = useSsrExperiments()

  const isDataDrivenSortExperimentEnabled =
    getExperienceIdForExperiment(
      readFromEnv(Env.SearchDataDrivenSortExperimentId),
    ) === 1

  const isDataDrivenSortOrderFlagEnabled =
    readFromEnv(Env.SearchDataDrivenSortOrder) === 'true'

  const shouldUseDataDrivenSortOrderAsDefault =
    isDataDrivenSortExperimentEnabled && isDataDrivenSortOrderFlagEnabled

  if (!storeRef.current) {
    storeRef.current = initialiseSearchStore({
      params,
      isInsideStoryblok,
      allCinchStores,
      pathSegmentsFromUrl,
      shouldUseDataDrivenSortOrderAsDefault,
    })
  }
  return (
    <SearchStoreContext.Provider value={storeRef.current}>
      {children}
    </SearchStoreContext.Provider>
  )
}
